/**
* @author vishwadeep.kapoor
* Profile
*
*/

import React, { PureComponent, Fragment } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Flex, Box } from 'grid-styled';

import { AppWrappperHOC } from '../Root/HOC';
import Container from '../../components/Container';
import WhiteBackground from '../../components/WhiteBackground';
import Input from '../../components/Input';
import Button from '../../components/Button';
import Radio from '../../components/Radio';
import RadioInput from '../../components/Radio/RadioInput';
import Modal from '../../components/Modal';

import { utils, constants, validations, eventTracking } from '../../devUtils';
import ValidationErrors from '../../components/ValidationErrors';
import { Loader } from '../../components';
import DatePickerWrapper from '../../components/DatepickerWrapper';
import ProfileNavigation from './ProfileNavigation';
import { ProfileProps, ProfileMapStateToProps, ProfileMapDispatchToProps } from './profileDataHandler';
import userIcon from '../../assets/images/user-icon.png';
import StyledCilentHeaders from '../GiftCard/StyledCilentHeaders';

const StyledProfile = styled.section`
  margin-top:50px;
  .margin-t-18{
    margin-top: 180px;
  }
  .margin-t-3{
    margin-top:30px;
  }
.profile{
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
    border-bottom:0px;
    };
    text-align:center;
    background:${(props) => props.theme.whiteColor};
    padding:10px 0px;
    position:relative;
    margin-bottom: 40px;
    img{
      border-radius:50%;
      width: 18%;
      border: #D5D3D3 solid 10px;
    }
    .profile-edit{
      margin: 0 auto;
    position: absolute;
    bottom: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background:${(props) => props.theme.whiteColor};
    border: ${(props) => props.theme.lightGray} solid 1px;
    padding: 7px 30px;
    border-radius: 20px;
    font-weight: 300;
    text-transform: uppercase;
    font-size: 12px;
    line-height: normal;
    cursor: pointer;
    }
  }
  ${Button}{
    padding:.78571429em 2.5em;
  }
  h1{
    margin:10px 0 15px 15px;
    font-size:24px;
  }
.textRight{
  text-align:right;
}
.textLeft{
  text-align:left;
  .pass-button{
    background: ${(props) => props.theme.transparentColor};
    border: 0;
    margin-top: 10px;
    font-size: 14px;
    cursor: pointer;
  }
}
.profile-nav{
  padding-right: 10px;
}
.my-account-nav{
  padding-left: 10px;
}
@media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
  .profile-nav, .my-account-nav{
    padding: 0px;
  }
  ${StyledCilentHeaders}{
    padding: 10px 0px 0px;
  }
};
.profile_left{
  font-family: 'Lato', sans-serif;
  padding:0px;
  position: relative;
  input{
    height:0px !important;
  }
  [type="checkbox"] {
    position: absolute;
    top: 0;
    display: block;
    width: 100%;
    z-index: 1;
    opacity: 0;
    height: 50px;
    cursor: pointer;
  }
  label:before,
  label:after {
    position: absolute;
  }
  label:before {
    left: 10px;
  }

label:after {
  content: '';
  position: absolute;
  left: 6px;
  width: 8px;
  height: 8px;
  -webkit-transform: rotate(-45deg);
          transform: rotate(-45deg);
}
  input[type="checkbox"] ~ ul {
    width: 100%;
    overflow: hidden;
    max-height: 1000px;
    @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
      max-height: 500px;
    };
    @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[0]}) {
      max-height: 50px;
    }
    transition: max-height .45s cubic-bezier(.44, .99, .48, 1);
  }
  [type="checkbox"]:checked ~ ul {
    max-height: 1000px;
  }
  
  [type="checkbox"]:checked + label {
    top: 100%;
  }
  
  ul{
    margin:0px;
    list-style:none;
    padding:0px;
    position:relative;
    span{
      @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[4]}) {
        display:none;
      };
      @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
        display:block;
      };
      &:after{
        content: '';
        position: absolute;
        right: 20px;
        top:15px;
        width: 12px;
        height: 12px;
        border-bottom: solid 2px currentColor;
        border-right: solid 2px currentColor;
        -webkit-transform: rotate(45deg);
        transform: rotate(45deg);
      }
    }
    @keyframes sudo {
      from {
        -webkit-transform: translateY(-2px);
        transform: translateY(-2px);
      }
      to {
        -webkit-transform: translateY(2px);
        transform: translateY(2px);
      }
    }
    li{
      display: block;
    cursor: pointer;
    padding: 15px 15px 15px 45px;
    margin-bottom: 5px;
    font-size: 14px;
    font-weight: 400;
    position: relative;
      img{
        width: 20px;
        position: absolute;
        left: 13px;
        top: 20px;
        height: 20px;
      }
      i{
        width: 20px;
        position: absolute;
        left: 13px;
        top: 17px;
        height: 20px;
        font-size: 19px;
        font-weight: bold;
      }
      strong{
        font-weight: normal;
    vertical-align: middle;
      }
      &:hover{
        color: ${(props) => props.theme.primaryColor};
        background-color: ${(props) => props.theme.whiteColor};
        border-radius: 5px;
        img{
            filter: invert(32%) sepia(54%) saturate(2685%) hue-rotate(335deg) brightness(93%) contrast(101%);
          }
        a{
          color: ${(props) => props.theme.primaryColor};
          img{
            filter: invert(32%) sepia(54%) saturate(2685%) hue-rotate(335deg) brightness(93%) contrast(101%);
          }
        }
      }
      a{
        text-decoration:none;
        color:${(props) => props.theme.secondaryColor};
        display:block;
      }
      &.active{
        color: ${(props) => props.theme.primaryColor};
        background-color: ${(props) => props.theme.whiteColor};
        border-radius: 5px;
        a{
          color: ${(props) => props.theme.primaryColor};
          img{
            filter: invert(32%) sepia(54%) saturate(2685%) hue-rotate(335deg) brightness(93%) contrast(101%);
          }
        }
      }
    }
  }
}
  .right-profile{
    border-radius:4px;
    button {
      &.gray-btn {
      background-color:${(props) => props.theme.lightWhite};
      color: ${(props) => props.theme.primaryColor};
      font-weight: normal;
    }
  }
  strong{
    display:block;
    margin-bottom:30px;
  }
  .formEmail{
    color: ${(props) => props.theme.mediumGrey};
    font-size: 11px;
    display: block;
    position: relative;
    border-radius: 4px;
    padding: 4px;
    b{
      color: ${(props) => props.theme.LandingBlack};
      margin-bottom: 12px;
    display: block;
    }
  }
  .formElement{
    color: ${(props) => props.theme.mediumGrey};
    font-size: 11px;
    display: block;
    position: relative;
    border: #DEDEDF solid 1px;
    border-radius: 4px;
    padding: 4px 10px;
    b{
      font-weight:normal;
    }
    .Select{
      border:1px solid rgba(34,36,38,.15);
      margin-top:10px;
    }
    .react-datepicker-wrapper{
      width:100%;
      .react-datepicker__input-container{
      width:100%;
      ${Input}{
        padding: .67857143em 0px;
        width: 100%;
        border:0px;
    }
      input{
        padding: .67857143em 0px;
        width: 100%;
        border:0px;
        font-size:14px;
        &:focus{
          outline:0px;
        }
      }
    }
    }
    ${Input}{
    display:block;
    padding: .67857143em 0px;
        width: 100%;
        border:0px;
        font-size:14px;
    }
    
    ${RadioInput}{
      padding:.67857143em 1em;
      margin:10px 0;
      label{
        color: ${(props) => props.theme.secondaryColor};
        font-weight:600;
        display:block;
        &:before{
          margin-right:10px;
        }
      }
    }
  }
}
.address{
  margin-top:20px;
  b{
    font-size:13px;
  }
  ${RadioInput}{
    display:inline-block;
    margin-right:20px;
    label{
      &:before{
      margin-right:10px;
    }
    }
  }
  .footer{
    text-align:right;
    font-size:12px;
    font-weight:600;
    margin-top:20px;
  }
  span{
    position: relative;
    display:block;
    font-size:13px;
    border-bottom:solid 1px ${(props) => props.theme.lightGray};
    padding-bottom:10px;
    p{
      width:80%;
      line-height:19px;
      margin-bottom:0px;
    }
    strong{
      position:absolute;
      right:0;
      font-size:13px;
      color: ${(props) => props.theme.mediumGrey};
      font-weight:normal;
    }
    i{
      position:absolute;
      right:0;
      bottom: 10px;
    }
  }
}
.Card_account_creation{
  background-color: ${(props) => props.theme.whiteColor};
  padding: 15px 30px 30px;
  margin-left:20px;
  border-radius: 8px;
  h4{
    opacity: 0.5;
  }
  .gray-text{
    color: ${(props) => props.theme.grayColor};
  }
  .red-text{
    color: ${(props) => props.theme.primaryColor};
  }
  ${Input}{
    padding: 10px;
    border:#DEDEDF solid 1px;
    font-size: 14px;
    border-radius:4px;
  }
  ${Button}{
    color: ${(props) => props.theme.whiteColor};
    background-color: ${(props) => props.theme.primaryColor};
    padding: 12px 24px;
    &.link{
      background-color:${(props) => props.theme.transparentColor};
      color: ${(props) => props.theme.primaryColor};
      padding: 0px !important;
      font-weight: normal;
    }
  }
}
`;

class Profile extends PureComponent {
  constructor(props) {
    super(props);
    const { UserDetails } = props;
    this.state = {
      UserDetails,
      showModal: false,
      date_of_birth: UserDetails.date_of_birth,
      wedding_anniversary: UserDetails.wedding_anniversary,
      isShowValidation: false,
      default_email: UserDetails && UserDetails.email,
      handleData: {},
    };
    this.validators = validations;
    this.handleChange = this.handleChange.bind(this);
    this.onPasswordClick = this.onPasswordClick.bind(this);
    this.saveChangePassword = this.saveChangePassword.bind(this);
    this.saveProfileClick = this.saveProfileClick.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
    this.triggerEmailChange = this.triggerEmailChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this._updateValidators = this._updateValidators.bind(this);
  }

  /**
   * @todo: moving the alert to seperate @function
   */
  componentWillReceiveProps(nextProps) {
    const { getProfile: { profileResponse }, UserDetails } = nextProps;
    if (!utils.isEqual(this.props, nextProps)) {
      if (profileResponse.message) {
        utils.showAlert(profileResponse.message);
      }
    }
    if (!utils.isEqual(this.props.UserDetails, nextProps.UserDetails)) {
      this.setState({ UserDetails });
    }
    if (nextProps.passwordUpdateStatus) {
      this.validators = utils.resetValidators(this.validators);
      this.setState({ showModal: false, handleData: {} });
    }
  }

  componentWillUnmount() {
    this.validators = utils.resetValidators(this.validators);
  }

  onPasswordClick() {
    const { showModal } = this.state;
    eventTracking.triggerEvent('My Account', 'Change Password Click');
    this.validators = utils.resetValidators(this.validators);
    this.setState({ showModal: !showModal, handleData: {} });
  }

  handleChange(type, value) {
    const { handleData } = this.state;
    handleData[type] = value;
    this.setState({ handleData: JSON.parse(JSON.stringify(handleData)) });
  }

  triggerEmailChange(type, value) {
    this.setState({ default_email: value });
    this.handleChange(type, value);
    eventTracking.triggerEvent('My Account', 'Change primary id');
  }

  handleDateChange(type, value) {
    const key = utils.getMoment(value, constants.DATE_DEAL_FORMAT);
    this.setState({ [type]: key });
    this.handleChange(type, key);
  }

  /**
   * @todo password validations
   * @todo field validations
   * @todo generic validation for all types of input
   */
  saveChangePassword() {
    const { handleData: { current_password, password } } = this.state;
    if (utils.isFieldRequired(this.validators, ['mandatory', 'password', 'confirmPassword'])) {
      this.setState({ isShowValidation: true });
    } else {
      this.setState({ isShowValidation: false });
      this.props.onPasswordChange({ current_password, password });
    }
  }

  saveProfileClick() {
    const { handleData: { date_of_birth, wedding_anniversary, name, email } } = this.state;
    const payload = utils.checkObjectValues({ date_of_birth, wedding_anniversary, name, email });
    this.props.onProfileChange(payload);
  }

  handleLogout() {
    const { history, onUserLogout, UserDetails: { client_series = '' } = {} } = this.props;
    onUserLogout(history, { client_series });
  }

  _updateValidators(type, value) {
    const { handleData: { password } } = this.state;
    if (type === 'confirmPassword') {
      this.validators = utils.updateValidators(this.validators, type, value, { password });
    } else {
      this.validators = utils.updateValidators(this.validators, type, value);
    }
  }

  renderModalFooter() {
    return <Button onClick={this.saveChangePassword}>Save</Button>;
  }

  renderOtherFields() {
    const {
      date_of_birth,
      wedding_anniversary,
    } = this.state;
    return (
      <Fragment>
        <Box width={[12 / 12, 6 / 12]} p={10}>
          <div className="formElement">
                      DOB (You should be at least 13 years old to have a Zaggle account.)
            <DatePickerWrapper
              handleChange={this.handleDateChange}
              selected={utils.getMoment(date_of_birth, null)}
              payloadKey="date_of_birth"
              maxDate={utils.getMoment(null, null)}
              calendarClassName="booking_calendar"
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              fixedHeight
            />
          </div>
        </Box>
        <Box width={[12 / 12, 6 / 12]} p={10}>
          <div className="formElement">
                      Anniversary Date (You need to be at least 18 years old.)
            <DatePickerWrapper
              handleChange={this.handleDateChange}
              selected={utils.getMoment(wedding_anniversary, null)}
              payloadKey="wedding_anniversary"
              maxDate={utils.getMoment(null, null)}
              calendarClassName="booking_calendar"
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
            />
          </div>
        </Box>
      </Fragment>
    );
  }

  render() {
    const {
      showModal,
      UserDetails: {
        isOnlyMerchandise,
        name,
        emails,
        phone,
        image: {
          thumb_url,
        } = {},
      },
      isShowValidation,
      default_email,
      handleData: {
        current_password = '',
        password = '',
        confirm_password = '',
      },
    } = this.state;
    const {
      isLoadingStatus,
      history,
    } = this.props;
    if (isLoadingStatus) {
      return <Loader />;
    }
    return (
      <StyledProfile className={isOnlyMerchandise ? 'nomargin' : ''}>
        <Container>
          <Modal
            show={showModal}
            classname="default"
            header="Change Account Password"
            onClose={this.onPasswordClick}
            footer={this.renderModalFooter()}
            size="sm"
          >
            <div className="formElement">
              <Input
                placeholder="Enter Current Password"
                type="password"
                onChange={(e) => {
                  this.handleChange('current_password', e.target.value);
                  this._updateValidators('mandatory', e.target.value);
                }}
                value={current_password}
                required
              />
              {isShowValidation && ValidationErrors(this.validators, 'mandatory')}
              <Input
                placeholder="New Password"
                type="password"
                onChange={(e) => {
                  this.handleChange('password', e.target.value);
                  this._updateValidators('password', e.target.value);
                }}
                value={password}
                required
              />
              {isShowValidation && ValidationErrors(this.validators, 'password')}
              <Input
                placeholder="Confirm new Password"
                type="password"
                onChange={(e) => {
                  this.handleChange('confirm_password', e.target.value);
                  this._updateValidators('confirmPassword', e.target.value);
                }}
                value={confirm_password}
                required
              />
              {isShowValidation && ValidationErrors(this.validators, 'confirmPassword')}
            </div>
          </Modal>
          <br clear="all" />
          <Flex flexWrap="wrap" className={isOnlyMerchandise ? 'nomargin' : 'margin-t-3'}>
            <Box width={[12 / 12, 5 / 24]} className="profile-nav">
              <ProfileNavigation history={history} />
            </Box>
            <Box width={[12 / 12, 19 / 24]} className="my-account-nav">
              <WhiteBackground className="right-profile">
                <div className="profile">
                  <img src={thumb_url || userIcon} alt="no_image" />
                </div>
                <Flex flexWrap="wrap">
                  <Box width={[12 / 12, 6 / 12]} p={10}>
                    <div className="formElement">
                      Full Name
                      <Input key={name} defaultValue={name} onChange={(e) => this.handleChange('name', e.target.value)} />
                    </div>
                  </Box>
                  <Box width={[12 / 12, 6 / 12]} p={10}>
                    <div className="formElement">
                        Phone
                      <Input key={phone} defaultValue={phone} disabled />
                    </div>
                  </Box>
                  <Box width={[12 / 12, 12 / 12]} p={10}>
                    <div className="formEmail">
                      <b> Email <br />(Selected Email ID is your primary Email ID)</b>
                      {emails && emails.map((item) => (
                        <Radio key={item} id={item} _onEventChange={this.triggerEmailChange} payloadKey="email" selectedOption={default_email}>
                          {item}
                        </Radio>
                      ))}
                    </div>
                  </Box>
                  { !isOnlyMerchandise && this.renderOtherFields() }
                </Flex>
                <Flex flexWrap="wrap">
                  <Box width={[12 / 12]} className="textRight">
                    <Button onClick={this.onPasswordClick} className="gray-btn" style={{ marginRight: '10px' }}>Change Password</Button>
                    <Button type="primary" onClick={this.saveProfileClick}>Save</Button>
                  </Box>
                </Flex>
              </WhiteBackground>
            </Box>
          </Flex>
        </Container>
      </StyledProfile>
    );
  }
}

Profile.propTypes = ProfileProps;

const component = connect(ProfileMapStateToProps, ProfileMapDispatchToProps)(AppWrappperHOC(Profile));
export { StyledProfile, Profile };
export default component;



// WEBPACK FOOTER //
// client/containers/Profile/index.js